import { useContext, useState } from 'react'

import { Layout, Menu, MenuProps, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useCallStatus, useUserProfileApi } from '../../hooks'
import { AosTokenContext } from '../../providers'
import { DeviceSettingModal, LanguageSwitchModal } from '../setting'

const StyledHeader = styled(Layout.Header)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const StyledTitle = styled(Typography)`
  color: white;
  font-size: 24px;
  font-weight: bold;
`

const StyledMenu = styled(Menu)`
  display: flex;
  justify-content: flex-end;
  min-width: 700px;
`

export const Header = () => {
  const [isLanguageModalOpen, setLanguageModalOpen] = useState(false)
  const [isDeviceModalOpen, setDeviceModalOpen] = useState(false)
  const { status } = useCallStatus()
  const { data: userProfile } = useUserProfileApi()
  const { setToken } = useContext(AosTokenContext)
  const navigate = useNavigate()
  const { t } = useTranslation('translation', {
    keyPrefix: 'components.Layout',
  })

  const languageModalOpen = () => {
    setLanguageModalOpen(true)
  }

  const languageModalClose = () => {
    setLanguageModalOpen(false)
  }

  const deviceModalOpen = () => {
    setDeviceModalOpen(true)
  }

  const deviceModalClose = () => {
    setDeviceModalOpen(false)
  }

  const menuItems: MenuProps['items'] = [
    {
      key: 'language',
      label: <div onClick={languageModalOpen}>{t('switchLanguage')}</div>,
    },
  ]

  if (status === 'calling') {
    menuItems.unshift({
      key: 'setting',
      label: <div onClick={deviceModalOpen}>{t('setting')}</div>,
    })
  }

  if (userProfile) {
    menuItems.push({
      key: 'userProfile',
      label: <div>{userProfile.name}</div>,
      children: [
        {
          key: 'logout',
          label: (
            <div
              onClick={() => {
                localStorage.removeItem('aosToken')
                localStorage.removeItem('aosTokenExpiry')
                setToken(null)
                navigate('/sign-in')
              }}
            >
              {t('logout')}
            </div>
          ),
        },
      ],
    })
  }

  return (
    <StyledHeader>
      <StyledTitle>suitebook Calls</StyledTitle>
      <StyledMenu theme="dark" mode="horizontal" items={menuItems} />
      <LanguageSwitchModal
        open={isLanguageModalOpen}
        onClose={languageModalClose}
      />
      {isDeviceModalOpen && (
        <DeviceSettingModal
          open={isDeviceModalOpen}
          onClose={deviceModalClose}
        />
      )}
    </StyledHeader>
  )
}
